import React, { createContext, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { StatusCode } from '../../components/Alert.tsx';
import CategoriesController from '../../controllers/CategoriesController.ts';
import { Category } from '../../models/category.ts';
import { useAlert } from '../alertProvider.tsx';

type CategoryContextType = {
    isLoaded?: boolean;
    category: Category;
    insertCategory: (entity: Category) => void;
    updateCategory: (entity: Category) => void;
};

const CategoryContext = createContext<CategoryContextType>({} as CategoryContextType);

export const CategoryContextProvider = ({ children, id }: { children: any, id?: any }) => {
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [category, setCategory] = useState<Category>({} as Category);
    const { showAlert } = useAlert();
    const navigate = useNavigate();
    useEffect(() => {
        const getCategoryByID = async () => {
            if (id == "create") { setIsLoaded(true); return; }
            try {
                const result = await CategoriesController.getByID(id);
                if (result.notificationStatus == StatusCode.success)
                    setCategory(result);
                else showAlert(result.notificationStatus, result.notificationMessage);
            } catch (error) {
                console.error('Error fetching category:', error);
            } finally {
                setIsLoaded(true);
            }
        }
        getCategoryByID();
    }, [id]);

    const insertCategory = async (entity: Category) => {
        try {
            const result = await CategoriesController.post(entity);
            if (result.notificationStatus == StatusCode.success)
                navigate(-1);
            else
                showAlert(result.notificationStatus, result.notificationMessage);
        } catch (error) {
            console.error('Error inserting category:', error);
        }
    }

    const updateCategory = async (entity: Category) => {
        try {
            const result = await CategoriesController.put(entity);
            if (result.notificationStatus == StatusCode.success)
                navigate(-1);
            else
                showAlert(result.notificationStatus, result.notificationMessage);
        } catch (error) {
            console.error('Error updating category:', error);
        }
    }

    const context: CategoryContextType = {
        isLoaded,
        category,
        insertCategory,
        updateCategory
    }

    return (
        <CategoryContext.Provider value={context}>
            {children}
        </CategoryContext.Provider>
    )
}

export const useCategoryContext = () => useContext(CategoryContext)
